//import menusSaga from "./menus/saga";
import partnersSaga from './partners/saga';
import partnersConfigSaga from './partnersConfig/saga';
import partnersApiSaga from './partnersApi/saga';
import exportSaga from './export/saga';
import supplementSaga from '../Components/SupplementExtra/service/saga';
import productQuantity from '../Components/ProductQuantity/service/saga';
import partnerCongigPartnerSaga from './partnersConfig/partners/saga';
import partnerDataSaga from './partnersData/saga';
import partnerLinkSaga from './partnersLink/saga';
import externalIdAssignationSaga from '../Components/ExternalDataAssignation/service/saga';
import partnerTaxRateSaga from '../Components/PartnerTaxRate/service/saga';
import { all } from 'redux-saga/effects';

export default function* indexSaga() {
	yield all([
		partnersSaga(),
		partnersConfigSaga(),
		partnersApiSaga(),
		partnerDataSaga(),
		partnerLinkSaga(),
		exportSaga(),
		supplementSaga(),
		productQuantity(),
		partnerCongigPartnerSaga(),
		externalIdAssignationSaga(),
		partnerTaxRateSaga(),
	]);
}
